import { E as EmblaCarousel } from './embla-carousel.esm-DpJzJcqm.js';
import { A as Autoplay, p as playAutoplay } from './autoplay-I8xLCyCo.js';
import { a as addAccessibility, A as Accessibility } from './accessibility-_zCLcLLO.js';
import { W as WheelGesturesPlugin } from './embla-carousel-wheel-gestures.esm-BxgUSOtT.js';

/**
 * @param {import('embla-carousel').EmblaCarouselType} emblaApi
 */
const preventDragSelection = (emblaApi) => {
  const root = emblaApi.rootNode();
  /** @param {Event} event */
  const preventDefault = (event) => event.preventDefault();

  emblaApi
    .on('pointerdown', () => {
      root.addEventListener('selectstart', preventDefault);
      root.addEventListener('dragstart', preventDefault);
    })
    .on('pointerup', () => {
      root.removeEventListener('selectstart', preventDefault);
      root.removeEventListener('dragstart', preventDefault);
    });
};

class PinpointsBannerSlider extends HTMLElement {
  /** @type {import('embla-carousel').EmblaCarouselType | undefined} */
  #embla;

  /** @type {number} */
  #autoplayDelay = Number(this.dataset.autoplay);

  connectedCallback() {
    this.#init();
  }

  #init() {
    const viewport = this.querySelector('.embla__viewport') ?? this;
    const plugins = [Accessibility(), WheelGesturesPlugin()];

    if (this.#autoplayDelay > 0) {
      plugins.push(Autoplay({ delay: this.#autoplayDelay }));
    }

    this.#embla = EmblaCarousel(
      viewport,
      {
        align: 'start',
        dragFree: true,
        slidesToScroll: 'auto',
        axis: 'x',
        breakpoints: {
          // Must stay in sync with the `md:flex-col` container in _pinpoints-banner-slider.liquid.
          '(min-width: 64rem)': {
            axis: 'y',
          },
        },
      },
      plugins
    );

    addAccessibility(this.#embla);
    preventDragSelection(this.#embla);

    if (this.#autoplayDelay > 0) {
      this.#tryAutoplay();
      this.#embla.on('reinit', this.#tryAutoplay.bind(this));
    }
  }

  disconnectedCallback() {
    this.#embla?.destroy();
    this.#embla = undefined;
  }

  #tryAutoplay() {
    if (this.#autoplayDelay > 0) {
      playAutoplay(this.#embla);
    }
  }
}

if (!customElements.get('pinpoints-banner-slider')) {
  customElements.define('pinpoints-banner-slider', PinpointsBannerSlider);
}
